function copy(val) {
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = val;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
      alert('Code Copied!');
    }

      var banner_slide = new Swiper('.banner_slide', {
            slidesPerView: 1.2, 
            spaceBetween: 10, 
             mousewheel: true,
        slidesOffsetAfter : 50,
            breakpoints: { //반응형 조건 속성
            
              768: {
                slidesPerView: 3,
                direction: 'vertical',
                touchRatio: 0
              },
              1024: {
                slidesPerView: 'auto',
                 direction: 'vertical',
                slideToClickedSlide: false,
              
         
              },
            }
      });
 $(function(){   
    //이벤트 팝업 슬라이드
        $('.banner_notice').click(function(){
          console.log('modal open');
          $('.banner_slide_wrap').addClass('modal-open');
        });
        
        $('.open_pop').click(function(){
          $('.banner_slide_wrap').removeClass('modal-open');
        });
   
        $(window).scroll(function() {
              if($(window).scrollTop() > 42) {
                  $('.banner_slide_wrap').addClass('active');
              } else {
                  $('.banner_slide_wrap').removeClass('active');
              }
          });
 });